module.exports = __webpack_public_path__ + "img/rememberall.71ac0d4d.jpg";